import { Modal } from 'react-bootstrap'
import { SenceSettingsForm } from '../SenceSettings'

interface modalSenceProps {
  show: boolean
  onClose(): void
}

const ModalSence: React.FC<modalSenceProps> = ({ show, onClose }) => {
  const handleOnClose = () => {
    onClose()
  }

  return (
    <Modal show={show} onHide={handleOnClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Integración Sence</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SenceSettingsForm />
      </Modal.Body>
    </Modal>
  )
}

export default ModalSence
